<template>
    <div class="container" style="margin-top:16.66%">
        <div class="form-login col-md-offset-4 col-md-4">
            <div @keyup.enter="login()">
                <h4>Changer votre mot de passe</h4>
                <input v-if="renewalState != 1" type="password" v-model="password" class="form-control input-sm chat-input" placeholder="Nouveau mot de passe" />
                <br>
                <div class="wrapper" v-if="renewalState != 1">
                    <span class="group-btn">
                        <button :disabled="!password.length" @click="send()" class="btn btn-primary btn-md">Valider</button>
                    </span>
                </div>
                <div class="text-center" style="margin-top:2%;" v-if="renewalState == 1">
                    Votre changement de mot de passe a été effectué avec succès. Vous allez être redirigé vers la page de connexion dans quelques secondes.
                </div>
                <div class="text-center" style="color:red;margin-top:2%;" v-if="renewalState == 2">
                    Votre demande n'a pas pu aboutir.<br>Veuillez réessayer plus tard.
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    computed: {
    },
    methods: {
        send() {
            let successCallback = (data) => {
                this.renewalState = 1;
                this.$store.commit("CURRENT_USER_UPDATED", {email: data.user});
                let self = this;
                setTimeout(function()   {
                    self.$router.push('/')
                }, 1000);
            };

            let errorCallback = (data) => {
                this.renewalState = 2;
            };

            this.$store.dispatch('userChangePassword', {
                newPassword: this.password,
                resetId : this.$route.params.resetId,
                callbacks: {
                    success: successCallback,
                    error: errorCallback
                }
            });
        }
    },
    data: function()  {
        return {
            password: "",
            renewalState: 0
        };
    }
};
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:400);
body {
    background-color:#fff;
    -webkit-font-smoothing: antialiased;
    font: normal 14px Roboto,arial,sans-serif;
}

.form-login {
    background-color: #EDEDED;
    padding-top: 10px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 15px;
    border-color:#d2d2d2;
    border-width: 5px;
    box-shadow:0 1px 0 #cfcfcf;
}

h4 {
    border:0 solid #fff;
    border-bottom-width:1px;
    padding-bottom:10px;
    text-align: center;
}

.form-control {
    border-radius: 10px;
}

.wrapper {
    text-align: center;
}


</style>
